// The Orders tab (011 FR-001).
import { OrdersScreen } from "@/orders/OrdersScreen";

export default function Orders() {
  return <OrdersScreen />;
}
